import React, { useState } from "react"
import { APICALL } from "helper/api/api"
import BTNLoading from "helper/my-com/BTNLoading"
import { toastifyError } from "helper/Utility"
import avatar from "../../assets/images/chatbot-avatar.png"
import { Link, useNavigate } from "react-router-dom"
import { useEffect } from "react"
import welcomeVideo from '../../assets/welcomeVideo.mp4'
import { useRef } from "react"
import { useLayoutEffect } from "react"
import ProductBox from "./ProductBox"

const ChatBotBox = ({ setIsPaneOpen }) => {
    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const [input, setInput] = useState("")
    const [messages, setMessages] = useState([])
    const [productSuggestion, setProductSuggestion] = useState({}) // one product object
    const navigate = useNavigate()
    const handleOptionClick = (option) => {
        setOpen(false)
        if (option == "newService") {
            navigate(`/gigs/addgigs`)
        } else if (option == "bookings") {
            navigate(`/utils/sales`)
        } else if (option == "serviceList") {
            navigate(`/gigs/viewgigs`)
        }
    }

    const handleSend = async () => {
        if (!input.trim()) return
        const userMessage = { type: "user", text: input }
        setMessages((prev) => [...prev, userMessage])
        setInput("")
        setLoading(true)
        setProductSuggestion({})
        try {
            const res = await APICALL("admin/chatBot", "POST", {
                reply: userMessage.text,
                isProduct: true,
                type: "vendor"
            })
            const data = res?.data
            const botReply = data?.reply || "🤖 Let me think about that..."
            console.log("response", res?.data)
            setMessages((prev) => [...prev, { type: "bot", text: botReply }])
            if (data?.isProduct && data?.product_data) {
                setProductSuggestion(data.product_data)
            }
        } catch (error) {
            toastifyError(error?.response?.data?.message || "❌ Server error")
        } finally {
            setLoading(false)
        }
    }

    const videoRef = useRef(null);
    const handlePlay = () => {
        if (videoRef.current) {
            const playPromise = videoRef.current.play();
            if (playPromise !== undefined) {
                playPromise.catch(error => {
                    console.error("Playback error:", error);
                });
            }
        }
    };

    useLayoutEffect(() => {
        handlePlay()
    }, []);

    const handlePause = () => {
        if (videoRef.current) {
            videoRef.current.pause();
        }
    };

    return (
        <>
            {/* Trigger Icon */}
            <div className="chatbot-widget-trigger" onClick={() => { setOpen(true); handlePlay() }}>
                <img src={avatar} alt="Chat Bot" style={{ width: 60, height: 60, borderRadius: "50%" }} />
            </div>

            {open && (
                <div className="chatbot-modal">
                    <div className="chatbot-container">
                        {/* Header */}
                        <div className="chatbot-header">
                            <div className="chatbot-avatar-title">
                                <img src={avatar} alt="Bot" />
                                <div>
                                    <strong>MyPlo GPT</strong>
                                    <div className="online-dot">
                                        <span className="online-pointer">●</span> Online
                                    </div>
                                </div>
                            </div>
                            <button className="close-btn" onClick={() => { setOpen(false); handlePause() }}>
                                ×
                            </button>
                        </div>

                        {/* Messages */}
                        <div className="chatbot-messages">
                            <div className="chatbot-welcome">
                                <h2>Welcome to MyPlo!</h2>
                                <p>I’m Reyko, your MyPlo assistant. What would you like to do first?</p>
                                {/* <img src={isImage ? myPloGirl : welcomeGif} alt="Bot" className="chatbot-avatar" style={{ width: "250px" }} /> */}
                                <video
                                    ref={videoRef}
                                    src={welcomeVideo}
                                    width="200"
                                    height="280"
                                    // muted
                                    playsInline
                                    controls={false}
                                    autoPlay
                                    style={{ objectFit: "cover", objectPosition: "top" }}
                                />

                                <div className="chatbot-options" style={{ marginTop: "-16px" }}>
                                    <button onClick={() => handleOptionClick("newService")}>List a New Service</button>
                                    <button onClick={() => handleOptionClick("bookings")}>Manage My Bookings</button>
                                    <button onClick={() => handleOptionClick("serviceList")}>Update Weekly Availability</button>
                                </div>
                            </div>
                            {messages.map((msg, idx) => (
                                <div className={`chat-bubble ${msg.type}`} key={idx}>
                                    {msg.text}
                                </div>
                            ))}

                            {productSuggestion?._id && (
                                <div className="chatbot-products-grid">
                                    <ProductBox item={productSuggestion} />
                                </div>
                            )}
                        </div>

                        {/* Footer */}
                        <div className="chatbot-footer">
                            <input type="text" placeholder="Ask me anything..." value={input} onChange={(e) => setInput(e.target.value)} onKeyDown={(e) => e.key === "Enter" && handleSend()} />
                            {loading ? (
                                <BTNLoading className="send-btn" />
                            ) : (
                                <button onClick={handleSend} className="send-btn">
                                    ➤
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default ChatBotBox
